import Modal from '../../components/modal.js';

class ImportFile {
  get dom() {
    return {
      HIERARCHY_FIELD_IMPORT: '#import_hierarchy_field_id',
      RTS_FIELD_IMPORT: '#import_rts',
    };
  }

  _resetImportModal() {
    $(this.dom.HIERARCHY_FIELD_IMPORT).val(this.selectedField);
    $(this.dom.RTS_FIELD_IMPORT).val('false');
  }

  showRTSImportModal(e) {
    $(this.dom.RTS_FIELD_IMPORT).val('true');
    if (!this.importRtsModal) {
      this.importRtsModal = new Modal({
        id: 'modal-rts-import',
        el: '.modal-rts-import',
      });
    }
    this.showImportModal(e, this.importRtsModal);
  }

  showFileImportModal(e, selectedField) {
    $(this.dom.HIERARCHY_FIELD_IMPORT).val(selectedField);
    this.showImportModal(e, null, selectedField);
  }

  showImportModal(e, customModal, selectedField) {
    var modal = customModal,
      self = this;

    this.selectedField = selectedField;

    if (!modal) {
      if (!this.importModal) {
        this.importModal = new Modal({
          id: 'modal-xml-import',
          el: '.modal-xml-import',
        });
      }
      modal = this.importModal;
    }
    modal.$el.css({
      marginTop: 0,
      top: '10%',
      width: '40%',
    });
    modal.show();
    modal.on('modalClosed', self._resetImportModal());
  }
}

module.exports = ImportFile;
